import { createReducer } from "../../core/core-redux/reducer/createReducer";
import { WMS_3D_LAYER_LOADING } from "./globe/wms-3d-layer-load/wms3dLayerLoading.action";
import { WMS_3D_LAYER_LOADED } from "./globe/wms-3d-layer-load/wms3dLayerLoaded.action";
import { wms3dLayerLoadingPartialReducer } from "./globe/wms-3d-layer-load/wms3dLayerLoading.reducer";
import { wms3dLayerLoadedPartialReducer } from "./globe/wms-3d-layer-load/wms3dLayerLoaded.reducer";

export interface Wms3dLayersState {
    loading: boolean;
}

export const wms3dLayersReducer = createReducer<Wms3dLayersState>(
    {
        loading: false,
    },
    {
        [WMS_3D_LAYER_LOADING]: wms3dLayerLoadingPartialReducer,
        [WMS_3D_LAYER_LOADED]: wms3dLayerLoadedPartialReducer,
    }
);
